export default "__VITE_ASSET__BRWS5__5__"